import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// Vino palette: navy ink, teal for field actions, pink for alerts, amber for data.
export default new Vuetify({
    rtl: true,
    theme: {
        themes: {
            light: {
                primary: '#020B2D',
                secondary: '#0B7F86',
                accent: '#FF1F6B',
                error: '#D6004F',
                success: '#0B7F86',
                warning: '#9A6400',
                info: '#1A2C6E',
            },
        },
    },
});
